"use client";
import { useEffect, useState } from "react";
import { Container, Skeleton, Text } from "@radix-ui/themes";
import { LayoutProps } from "@/components/layout/layoutType";
import Icon from "@/components/common/icon/sicon";
import IntroLink from "./introLink";
//import dynamic from "next/dynamic";
//const SIcon = dynamic(() => import("@/components/common/icon/sicon"), { ssr: false });

const sample_link = process.env.NEXT_PUBLIC_LINK_SAMPLE_BREWING ?? "https://coffeein.site/info/brewing/roaster/EfDW6wfhHsO2gAqaR9Il8Q";
export default function BrewingNoteIntro({ params }: { params?: LayoutProps }) {
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <Container size="1" className=" mt-16 lg:mt-32 text-center">
      <Skeleton loading={loading}>
        <Icon
          iconType="phosphor"
          iconName="Drop"
          className={
            "size-48 inline-block group animate-fade-down animate-infinite animate-duration-[3000ms] animate-normal animate-fill-forwards"
          }
          weight="duotone"
          size={48}
        />
      </Skeleton>

      <IntroLink {...params} intro_text="brewingnote_intro" sample_link={sample_link} />
    </Container>
  );
}
